export type WorkMode = 'CREATE' | 'EDIT' | 'READ' | 'COPY';

export const WorkMode = {
    CREATE: 'CREATE' as WorkMode,
    EDIT: 'EDIT' as WorkMode,
    READ: 'READ' as WorkMode,
    COPY: 'READ' as WorkMode,
};
